export enum ConfigManagerPropertiesEnum {
  BuildVersion = 'buildVersion',
  Region = 'region',
  Production = 'production',
  IsProd = 'isProd',
  AppName = 'appName',
  SnackBarDurationInMs = 'snackBarDurationInMs',
  SrnRuleEditRoles = 'srnRuleEditRoles',
  InvoicePrefRuleEditRoles = 'invoicePrefRuleEditRoles',
  BillingInstructionsEditRoles = 'billingInstructionsEditRoles',
  InvoiceAccuracyRuleEditRoles = 'invoiceAccuracyRuleEditRoles',
  FeedbackSubject = 'feedbackSubject',
  FeedbackToAddress = 'feedbackToAddress',
  LoggedInUserRoot = 'loggedInUserRoot'
}
